import http from '@/utils/http';
const base_path = '/v2/channelInterface';

/**
 * 渠道接口类型选择器接口
 * @returns {Promise<Object>}
 */
export const getChannelInterfaceApi = () => {
  return http.get({ url: `${base_path}/selector` });
};
